import React, { useEffect, useState } from 'react';
import './ArtistModal.css';

function ArtistModal({ isOpen, onClose, artist }) {

    const [bgLoaded, setBgLoaded] = useState(false);

    useEffect(() => {
    if (!isOpen) return;
        setBgLoaded(false);

        const img = new Image();
        img.src = '/modal-background_result.webp';

        img.onload = () => setBgLoaded(true);
        img.onerror = () => setBgLoaded(true); // fail open

    }, [isOpen]);


    // Freeze background scroll
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    if (!isOpen || !artist) return null;

    function renderPieces(piecesString) {
        if (!piecesString) return null;

        // Remove wrapping brackets/quotes
        const cleaned = piecesString.replace(/^["\[]+|["\]]+$/g, '').trim();

        // Detect label
        const labelMatch = cleaned.match(/^(Title|Song):/i);
        if (!labelMatch) return null;

        const label = labelMatch[1]; // "Title" or "Song"

        // Remove the label from the start
        const content = cleaned.replace(new RegExp(`^${label}:`, 'i'), '').trim();

        let items = [];

        if (label.toLowerCase() === 'title') {
            // Titles are separated by repeated "Title:"
            items = cleaned
                .split(/Title:/i)
                .filter(Boolean)
                .map(item => item.trim());
        } else if (label.toLowerCase() === 'song') {
            // Songs are comma-separated
            items = content
                .split(',')
                .map(item => item.trim())
                .filter(Boolean);
        }

        return items.map((item, index) => (
            <div key={index}>
                <i>{label}: {item}</i>
            </div>
        ));
    }

    return (
        <div className="artistModalOverlay" onClick={onClose} >
            <div
                className="artistModal"
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundImage: 'url(/modal-background_result.webp)',
                }}
            >

            {!bgLoaded && (
                <div className="modalSpinnerOverlay">
                    <div className="spinner" />
                </div>
            )}

            <button className="modalClose" onClick={onClose}>
                x
            </button>

            <div className='modalContent' style={{ visibility: bgLoaded ? 'visible' : 'hidden' }}>
                <div className='artistNameWrapper'>
                    {artist.firstName && (
                    <img
                        src={`/beads/${artist.firstName}.png`}
                        alt={artist.name}
                        loading="lazy"
                        className='artistNameTitle'
                    />
                    )}
                    {artist.lastName && (
                        <img
                            src={`/beads/${artist.lastName}.png`}
                            alt={artist.name}
                            loading="lazy"
                            className='artistNameTitle'
                        />
                    )}
                </div>
                <div className='bio'>
                    {artist.bio}
                </div>
                <div className='pieces'>
                    {renderPieces(artist.pieces)}
                </div>
                {artist.instagram && (
                    <div className='instagram'>
                        Instagram: <a href={`https://instagram.com/${artist.instagram.slice(1)}`} target="_blank" rel="noopener noreferrer">{artist.instagram}</a>
                    </div>
                )}
                {artist.website && (
                    <div className='website'>
                        Website: <a href={`https://${artist.website}`} target="_blank" rel="noopener noreferrer">{artist.website}</a>
                    </div>
                )}
                {artist.email && (
                    <div className='email'>
                        Email: {artist.email}
                    </div>
                )}
                {artist.vimeo && (
                    <div className='vimeo'>
                        Vimeo: <a href={`https://${artist.vimeo}`} target="_blank" rel="noopener noreferrer">{artist.vimeo}</a>
                    </div>
                )}
                {artist.spotify && (
                    <div className='spotify'>
                        Spotify: <a href={`https://${artist.spotify}`} target="_blank" rel="noopener noreferrer">{artist.spotify}</a>
                    </div>
                )}
            </div>
        </div>
    </div>
    );
}

export default ArtistModal;